export default "__VITE_PUBLIC_ASSET__43534117__"